import React from 'react';
import { Box, theme } from '@xometry/xometry_loft';

const RegistrationHeader = () => {
  return (
    <>
      <Box
        fontFamily={theme.fonts[0]}
        fontSize="28px"
        lineHeight="36px"
        color={theme.colors.darkBlues[100]}
        textAlign="center"
        paddingX={theme.space[5]}
        marginBottom={theme.space[4]}
      >
        Create your account to continue
      </Box>
    </>
  );
};

export default RegistrationHeader;
